import { computed } from 'mobx'
import { makeObservableRowBase, RowBase } from 'shared/ui/TableNew/model/RowBase'
import type { ITableModelDefault } from 'shared/ui/TableNew'
import type { ConversationsAnalyticsKeys } from 'entities/Analytics/api/types'
import type { AnalyticsComparisonEntity } from 'pages/analytics/ui'

export interface IConversationsComparisonData extends ITableModelDefault {
  id: string | number
  name: string
  metrics: Record<ConversationsAnalyticsKeys, number>
  breakdownEntity?: AnalyticsComparisonEntity
}

export class RowConversationsComparison extends RowBase<IConversationsComparisonData> {
  constructor(data: IConversationsComparisonData) {
    super(data)

    makeObservableRowBase(this, {
      fields: computed,
    })
  }

  get fields() {
    return {
      name: this.origin.name,
      open: this.origin.metrics.open,
      closed: this.origin.metrics.closed,
      total: this.origin.metrics.total,
      new: this.origin.metrics.new,
      breakdownEntity: this.origin.breakdownEntity,
    }
  }
}
